import { render, staticRenderFns } from "./IconPTplus.vue?vue&type=template&id=fe2e55c8&"
import script from "./IconPTplus.vue?vue&type=script&lang=js&"
export * from "./IconPTplus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports